import { ChangeEvent, memo, useEffect, useRef, useState } from 'react';
// import { tripsService } from '../../services/trips.service';
import { LatLng, StopLocation, Trip, TripStopLabelStruct } from '../../store/config/types/trips.types';
import DndTimelineChart, { DndTimeLineChartItem, DndTimelineChartRow } from '../DndTimelineChart/DndTimelineChart';
import moment from 'moment-timezone';
import TripDndItemToolTip from './TripDndItemToolTip';
import TripViewTripActions from './TripViewTripActions';
import TripViewTripMetrics from './TripViewTripMetrics';
import { Courier, CustomerLocationOrder } from '../../store/config/types';
import TripDndItem from './TripDndItem';

import { Add, Delete, Edit, Refresh, SaveAlt, SupervisedUserCircle, Visibility } from '@material-ui/icons';
import { FormControlLabel, Grid, IconButton, Switch } from '@mui/material';
import SendToToday from './SendToToday';
import DatePicker from '../DatePicker/DatePicker';
import Map from '../Map/Map';
import { Warehouse } from '../../store/config/types/warehouses.types';
import { getStopSequence, stopToDndItem } from './helper';
import Spinner from '../Spinner/Spinner';
import { calculateTripScores, customerLabel } from '../../utils/trips.helper';
import { TripInfoPanel } from './TripInfoPanel';
import tripsService from '../../services/trips.service';
import TripDndItemSpacer from './TripDndItemSpacer';
import TripsScoreCard, { TripScoreType } from '../TripsScoreCard';
import MenuMore from '../MenuMore/MenuMore';

interface TripViewProps {
  trips: Trip[];
  warehouses?: Warehouse[];
  unAssignedOrders: CustomerLocationOrder[];
  date: string;
  shipperId?: number;
  couriers?: Courier[];
  timezone?: string;
  computedToggle?: boolean;
  trackedToggle?: boolean;
  canComputeStops?: boolean;
  lastTripUpdate?: Date;
  labels: TripStopLabelStruct[];
  isLoading?: boolean;
  adminMode?: boolean;
  /* eslint-disable */
  onTripMenuAction?: (tripId: number | undefined, menuAction: string) => void;
  onCustomAction?: (actionParams: any, actionName: string) => void;
  onActionButtonClick?: (tripIds: number[], actionName: string) => void;
  onNeedRefresh?: () => void;
  onUpdateClicked?: () => void;
  handleDateChane?: (e: ChangeEvent<HTMLInputElement>) => void;
  /* eslint-enable */
}
function TripView({
  trips,
  warehouses,
  date,
  // shipperId,
  unAssignedOrders,
  couriers,
  timezone,
  computedToggle = false,
  trackedToggle = false,
  canComputeStops = false,
  lastTripUpdate,
  isLoading,
  adminMode,
  onUpdateClicked,
  onTripMenuAction,
  onActionButtonClick,
  onCustomAction,
  handleDateChane,
  labels,
}: TripViewProps) {
  const [tripRows, setTripRows] = useState<DndTimelineChartRow[]>([]);
  const rowOrderRef = useRef<number[]>([]);
  const [unAssignedItems, setUnAssignedItems] = useState<DndTimeLineChartItem[]>([]);
  const [displayComputed, setDisplayComputed] = useState<boolean>(false);
  const [displayTracked, setDisplayTracked] = useState<boolean>(false);
  const [mapTripVisibility, setMapTripVisibility] = useState<{ tripId: number; visibility: boolean }[]>([]);
  const [allTripIsVisible, setAllTripIsVisible] = useState(true);
  const [highLightedStopId, setHighLightStopId] = useState(0);
  // const [highLightedCustomerId, setHighLightCustomerId] = useState(0);
  const [highlightLocationId, setHighlightLocationId] = useState(0);
  const [highLightedCourierId, setHighLightCourierId] = useState(0);
  const [mapBoundPoints, setMapBoundPoints] = useState<LatLng[]>([]);
  const [mapAdditionalMarkers, setMapAdditionalMarkers] = useState<any[]>([]);
  const [mapFocusedPoint, setMapFocusedPoint] = useState<LatLng>();
  const [mapZoom, setMapZoom] = useState<number>(10);

  const [mapNeedsRebound, setMapNeedsRebound] = useState(false);
  const [activeCouriers, setActiveCouriers] = useState<Courier[]>([]);
  const [tripToDisplayDetails, setTripToDisplayDetails] = useState<Trip>();
  const [tripToDisplayDetailsColorIndex, setTripToDisplayDetailsColorIndex] = useState<number>();
  const [tripToDisplayDetailsCurrentParking, setTripToDisplayDetailsCurrentParking] = useState<number>();
  const [tripToDisplayDetailsCurrentStop, setTripToDisplayDetailsCurrentStop] = useState<number>();

  const wrapperRef = useRef<HTMLDivElement>(null);
  const [viewportWidth, setViewportWidth] = useState(100);

  const [tripScores, setTripScores] = useState<TripScoreType[]>([]);

  // const [trips] = useState(tripsToShow);
  timezone && moment.tz.setDefault(timezone);

  // trips?.forEach((trip) => {
  //   trip.tripStops.forEach((stop, stopIndex) =>
  //     labels.push({
  //       tripStopId: stop.tripStopId,
  //       label: `${stopIndex ? stopIndex : 'W'}`,
  //     }),
  //   );
  // });

  const getEditableTripIds = () => {
    return trips.filter((trip) => ['NEW'].includes(trip.status)).map((trip) => trip.tripId ?? 0);
  };
  const getUnvisibleTripIds = () => {
    return mapTripVisibility.filter((t) => !t.visibility).map((t) => t.tripId);
  };
  const handleAction = (action: string, params?: any) => {
    switch (action) {
      case 'map-focus':
        setMapFocusedPoint({ lat: params.lat, lng: params.lng });
        if (params.zoom) setMapZoom(params.zoom);
        break;
      case 'map-bound-change':
        setMapBoundPoints(params);
        break;
      case 'map-display-markers':
        setMapAdditionalMarkers(params);
        break;
      case 'map-clear-markers':
        setMapAdditionalMarkers([]);
        break;
      case 'map-parking-click':
        setHighLightStopId(0);
        handleTripInfoPanelOpen(params.tripId, params.tripParkingId);
        break;
      case 'set-highligh-stop':
        setHighLightStopId(params);
        break;
      case 'set-parking-additional-data':
        // { tripParkingId: item.id, type, purpose }
        // tripsService.LocationsPathService.setTripParkingAdditionalData(params.tripParkingId, {
        //   type: params.type,
        //   purpose: params.purpose,
        // });
        tripsService.LocationsPathService.reloadTripParkings(params.tripId);
        break;
      default:
        if (onActionButtonClick !== undefined) onActionButtonClick(getEditableTripIds(), action);
    }
  };
  const handleSendToToday = async (unAssignIdx: number) => {
    if (unAssignedItems.length > unAssignIdx) {
      if (onCustomAction !== undefined)
        onCustomAction(
          {
            packageGroupsIds: unAssignedItems[unAssignIdx].additionalInfo.packageGroupsIds,
          },
          'sendToToday',
        );
    }
  };

  // const hadleDetailsClick = (item: DndTimeLineChartItem) => {
  //   if (onCustomAction !== undefined) onCustomAction({ tripStopId: item.additionalInfo.tripStopId }, 'moreStopDetails');
  // };
  const setTripVisibilityOnMap = (tripId: number, value?: boolean) => {
    const tIndex = mapTripVisibility.findIndex((vInfo) => vInfo.tripId === tripId);
    let changed = false;
    if (tIndex < 0) {
      mapTripVisibility.push({ tripId, visibility: true });
      changed = true;
    } else if (value !== undefined) {
      changed = mapTripVisibility[tIndex].visibility != value;
      mapTripVisibility[tIndex].visibility = value;
      if (value === false) {
        setAllTripIsVisible(false);
      }
    }
    if (changed) {
      setMapTripVisibility([...mapTripVisibility]);
    }
  };

  const handleAllTripVisibilityClick = () => {
    let visibility = true;
    if (allTripIsVisible) {
      visibility = false;
    }
    trips?.forEach((trip) => setTripVisibilityOnMap(trip.tripId ?? 0, visibility));
    setAllTripIsVisible(visibility);
  };

  const extractCustomerLocationFromOrder = (order: CustomerLocationOrder): StopLocation => {
    return {
      ...order.shippingLocation,
      customer: order.customer,
    } as StopLocation;
  };
  const onStopTooltipOpen = (rowIndex: number, itemIndex: number, isOpen: boolean) => {
    if (isOpen) setHighLightStopId(trips[rowIndex].tripStops[itemIndex].tripStopId);
    else setHighLightStopId(0);
  };

  const handleStopHover = (stopId: number, isOver: boolean) => {
    if (isOver) {
      setHighLightStopId(stopId);
    } else {
      setHighLightStopId(0);
    }
  };

  const handleUnassignHover = (customerId: number, isOver: boolean) => {
    if (isOver) {
      // setHighLightCustomerId(customerId);
    } else {
      // setHighLightCustomerId(0);
    }
  };

  const onUnassignedTooltipOpen = (itemIndex: number, isOpen: boolean) => {
    if (isOpen) {
      // setHighLightCustomerId(unAssignedOrders[itemIndex].customerId);
    } else {
      // setHighLightCustomerId(0);
    }
  };

  const handleOnCourierClick = (courierId: number) => {
    setHighLightCourierId(courierId);
  };

  const handleOnItemClick = (item: DndTimeLineChartItem) => {
    setHighLightStopId(item.additionalInfo?.tripStopId ?? 0);
  };
  const handleOnItemDoubleClick = (item: DndTimeLineChartItem) => {
    const stopId = item.additionalInfo?.tripStopId ?? 0;
    const stopLocation = trips[item.additionalInfo?.tripIndex ?? 0].tripStops.find(
      (stop) => stop.tripStopId === item.additionalInfo.tripStopId,
    )?.location;
    setHighLightStopId(stopId);
    if (stopLocation) setMapBoundPoints([{ lat: stopLocation.latitude, lng: stopLocation.longitude }]);
  };
  const handleOnUnassignedItemClick = (itemIndex: number) => {
    // setHighLightCustomerId(unAssignedOrders[itemIndex].customerId);
    setHighlightLocationId(unAssignedOrders[itemIndex].shippingLocationId);
  };
  const handleTripMenuAction = (tripId: number | undefined, menuAction: string) => {
    if (menuAction == 'details') {
      handleTripInfoPanelOpen(tripId);
    } else if (onTripMenuAction) {
      onTripMenuAction(tripId, menuAction);
    }
  };

  const handleTripInfoPanelOpen = (tripId?: number, parkingId?: number, stopNumber?: number) => {
    if (stopNumber !== undefined && stopNumber !== tripToDisplayDetailsCurrentStop) {
      setTripToDisplayDetailsCurrentStop(stopNumber);
      setTripToDisplayDetailsCurrentParking(undefined);
    }
    if (parkingId !== undefined && parkingId !== tripToDisplayDetailsCurrentParking) {
      setTripToDisplayDetailsCurrentStop(undefined);
      setTripToDisplayDetailsCurrentParking(parkingId);
    }

    if (tripId === tripToDisplayDetails?.tripId) {
      return;
    }
    const tripIndex = trips.findIndex((t) => t.tripId === tripId);
    if (tripIndex >= 0) {
      trips?.forEach((trip) => setTripVisibilityOnMap(trip.tripId ?? 0, trip.tripId === tripId));
      setAllTripIsVisible(false);
      setTripToDisplayDetails(trips[tripIndex]);
      setTripToDisplayDetailsColorIndex(trips[tripIndex].additionalData?.colorPaletteIndex ?? tripIndex);
      setMapNeedsRebound(true);
    }
  };

  const handleTripInfoPanelClose = () => {
    setTripToDisplayDetails(undefined);
    setTripToDisplayDetailsColorIndex(undefined);
    setTripToDisplayDetailsCurrentParking(undefined);
    setTripToDisplayDetailsCurrentStop(undefined);
  };

  const reBoundMap = () => {
    if (!highLightedStopId) {
      if (mapTripVisibility.some((tripInfo) => tripInfo.visibility)) {
        const allPointsOfVisibleTrips: LatLng[] = [];
        mapTripVisibility
          .filter((tripInfo) => tripInfo.visibility)
          .forEach((tripInfo) => {
            const foundedTrip = trips.find((trip) => trip.tripId === tripInfo.tripId);
            if (foundedTrip) {
              foundedTrip.tripStops?.forEach((stop) => {
                allPointsOfVisibleTrips.push({
                  lat: stop.location.latitude,
                  lng: stop.location.longitude,
                });
              });
            }
          });
        setMapBoundPoints(allPointsOfVisibleTrips);
      } else {
        if (unAssignedOrders.length > 0) {
          setMapBoundPoints(
            unAssignedOrders.map((order) => ({
              lat: order.shippingLocation?.latitude ?? order.customer?.location?.latitude,
              lng: order.shippingLocation?.longitude ?? order.customer?.location?.longitude,
            })),
          );
        } else {
          setMapBoundPoints(
            warehouses
              ?.filter((warehouse) => warehouse.location?.latitude && warehouse.location?.longitude)
              .map((warehouse) => ({
                lat: warehouse.location.latitude,
                lng: warehouse.location.longitude,
              })) ?? [],
          );
        }
      }
    }
    setMapNeedsRebound(false);
  };

  useEffect(() => {
    const newRows: DndTimelineChartRow[] = [];

    trips.map((trip, tripIndex) => {
      setTripVisibilityOnMap(trip.tripId ?? 0);
      if (trip.tripStops) {
        const stopSequence = getStopSequence(trip.tripStops, !isToday && displayComputed);

        newRows.push({
          index: trip.tripId,
          dropable: false,
          items: stopSequence.map((stopInfo) => {
            const stopIndex = trip.tripStops.findIndex((s) => s.tripStopId === stopInfo.tripStopId);
            const stop = trip.tripStops[stopIndex];
            if (highLightedStopId === stop.tripStopId) {
              handleTripInfoPanelOpen(trip.tripId ?? 0, undefined, stopIndex);
            }
            return stopToDndItem(
              trip,
              stop,
              tripIndex,
              stopIndex,
              highLightedStopId === stop.tripStopId,
              timezone,
              !isToday && displayComputed,
              labels,
            );
          }),
          additionalInfo: {
            colorIndex: trip.additionalData?.colorPaletteIndex ?? tripIndex,
          },
        });
      }
    });
    // Preserve user's manual row order if rows were reordered
    if (rowOrderRef.current.length > 0) {
      const orderedRows: DndTimelineChartRow[] = [];
      // Add rows in the user's reordered sequence
      rowOrderRef.current.forEach((tripId) => {
        const match = newRows.find((r) => r.index === tripId);
        if (match) orderedRows.push(match);
      });
      // Append any new rows not in the existing order
      newRows.forEach((row) => {
        if (!orderedRows.find((r) => r.index === row.index)) {
          orderedRows.push(row);
        }
      });
      setTripRows(orderedRows);
    } else {
      setTripRows(newRows);
    }
    // setIsMapLoading(false);

    // open details panel
  }, [trips, displayComputed, highLightedStopId]);

  useEffect(() => {
    const unAssigned: DndTimeLineChartItem[] = [];
    const isToday = moment().isSame(date, 'day');
    unAssignedOrders.forEach((deliveryOrder, dIndex) => {
      const label = customerLabel(deliveryOrder.customer, dIndex);
      const packageCount = deliveryOrder.packageGroups.reduce(
        (count, packageGroup) => count + (packageGroup.packages?.length ?? 0),
        0,
      );
      unAssigned.push({
        dragable: !isToday,
        start: moment(),
        end: moment(),
        label,
        colorClass: `color-unassigned`,
        additionalInfo: {
          name: deliveryOrder.customer
            ? `${deliveryOrder.customer.firstName} ${deliveryOrder.customer.lastName}`
            : undefined,
          companyName: deliveryOrder.customer ? `${deliveryOrder.customer.companyName ?? ''}` : undefined,
          warehouseName: deliveryOrder.warehouse ? `${deliveryOrder.warehouse.name ?? ''}` : undefined,
          packageGroupsIds: deliveryOrder.packageGroups.map((packageGroup) => packageGroup.packageGroupId),
          customerId: deliveryOrder.customerId,
          shipToAddressee: deliveryOrder.shipToAddressee,
          packageCount,
        },
        highlight: highlightLocationId === deliveryOrder.shippingLocationId,
      });
    });

    setUnAssignedItems(unAssigned);
    // setIsMapLoading(false);
  }, [unAssignedOrders, highlightLocationId]);

  useEffect(() => {
    // setIsMapLoading(true);
    setMapNeedsRebound(true);
  }, [date, trips, unAssignedOrders]);

  useEffect(() => {
    const visibleTripIds = mapTripVisibility.filter((v) => v.visibility).map((v) => v.tripId);
    setTripScores(calculateTripScores(trips.filter((t) => visibleTripIds.includes(t.tripId ?? 0)) as any[]));
  }, [trips, mapTripVisibility]);

  useEffect(() => {
    handleTripInfoPanelClose();
  }, [date]);

  useEffect(() => {
    if (mapNeedsRebound) reBoundMap();
  }, [mapNeedsRebound]);

  useEffect(() => {
    if (couriers && couriers.length) {
      setActiveCouriers(
        couriers.filter(
          (courier) =>
            courier.online &&
            courier.locationHistory?.length &&
            moment().isSame(courier.locationHistory[0].locationAt, 'day'),
        ),
      );
    }
  }, [couriers]);
  useEffect(() => {
    const element = wrapperRef?.current;
    if (!element) return;
    const observer = new ResizeObserver((entities) => {
      setViewportWidth(entities[0].contentRect.width);
    });
    observer.observe(element);
    return () => {
      observer.disconnect();
    };
  }, []);

  // if (trips.length === 0 && unAssignedItems.length === 0) return null;
  const isToday = moment(date).isSame(moment(), 'day');
  const editable = isToday || moment(date).isAfter(moment().startOf('day'));

  const handleRowReorder = (sourceIndex: number, destIndex: number) => {
    setTripRows((prev) => {
      const result = Array.from(prev);
      const [removed] = result.splice(sourceIndex, 1);
      result.splice(destIndex, 0, removed);
      rowOrderRef.current = result.map((r) => r.index ?? -1);
      return result;
    });
  };

  return (
    <div className="trips-dnd-full-page">
      <div className="trips-dnd">
        <div className="trips-dnd-title-area">
          <Grid className="trips-dnd-title-date">
            <DatePicker
              value={moment(date).format('YYYY-MM-DD')}
              hiddenLabel
              onChange={isLoading ? () => {} : handleDateChane ?? (() => {})}
              style={{ color: 'white' }}
            />
          </Grid>
          <Grid flexGrow={1} textAlign="left" pr={2} pl={2}>
            <Grid container alignContent="center" alignItems="center">
              <Grid>
                <IconButton
                  size="small"
                  onClick={() => {
                    onCustomAction && onCustomAction({}, 'CSV');
                  }}
                >
                  <SaveAlt style={{ color: 'white' }} />
                </IconButton>
              </Grid>
              {adminMode && (
                <Grid>
                  <Grid container alignContent="center" alignItems="center" style={{ opacity: 0.6 }}>
                    <SupervisedUserCircle /> Admin Mode
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>

          <Grid className="trips-dnd-title-actions">
            {isToday && (
              <>
                <IconButton size="small" onClick={onUpdateClicked}>
                  <Refresh style={{ color: 'white' }} />
                </IconButton>
                <span>Update @ {moment(lastTripUpdate).format('h:mm a')}</span>
              </>
            )}
            {trackedToggle && (
              <FormControlLabel
                control={
                  <Switch
                    value={displayTracked}
                    title="Display Tracked Points"
                    size="small"
                    onChange={(e) => {
                      setDisplayTracked(e.currentTarget.checked);
                    }}
                  />
                }
                label={'Actual'}
                labelPlacement="start"
              />
            )}
            {computedToggle && (
              <FormControlLabel
                disabled={editable}
                control={
                  <Switch
                    value={displayComputed}
                    title="Display Computed"
                    size="small"
                    onChange={(e) => {
                      setDisplayComputed(e.currentTarget.checked);
                    }}
                  />
                }
                label={'Computed'}
                labelPlacement="start"
              />
            )}
            {editable && (
              <IconButton
                size="small"
                onClick={() => {
                  handleAction('edit');
                }}
              >
                <Edit style={{ color: 'white' }} />
              </IconButton>
            )}
            {unAssignedItems.length > 0 && (
              <IconButton
                size="small"
                onClick={() => {
                  handleAction('create');
                }}
              >
                <Add style={{ color: 'white' }} />
              </IconButton>
            )}
          </Grid>
        </div>
        <div className="info-wrapper">
          <div className="trips-panel">
            <TripInfoPanel
              trip={tripToDisplayDetails}
              onClose={handleTripInfoPanelClose}
              couriers={couriers}
              displayComputed={displayComputed}
              colorIndex={tripToDisplayDetailsColorIndex}
              parkingId={tripToDisplayDetailsCurrentParking}
              stopNumber={tripToDisplayDetailsCurrentStop}
              onAction={handleAction}
              adminMode={adminMode}
            />
          </div>
          <div className="trips-wrapper" ref={wrapperRef}>
            <div className={`map-area${isLoading ? ' loading' : ''}`}>
              <div className="spinner">
                <Spinner />
              </div>
              <Map
                trips={trips}
                isLoading={isLoading}
                labels={labels}
                warehouses={warehouses}
                visibleTripsIds={mapTripVisibility
                  .filter((tripInfo) => tripInfo.visibility)
                  .map((tripInfo) => tripInfo.tripId)}
                customersLocations={unAssignedOrders.map((order) => extractCustomerLocationFromOrder(order))}
                displayTracked={displayTracked}
                couriers={isToday ? activeCouriers : []}
                highlightStopId={highLightedStopId}
                highlightLocationId={highlightLocationId}
                highlightedCourierId={highLightedCourierId}
                zoom={mapZoom}
                onStopHover={handleStopHover}
                onCustomerHover={handleUnassignHover}
                locationsDistanceType={!isToday && displayComputed ? 'track' : 'router'}
                boundPoints={mapBoundPoints}
                additionalMarkers={mapAdditionalMarkers}
                focusedPoint={mapFocusedPoint}
                onCourierClick={handleOnCourierClick}
                onMapClick={() => {
                  // setHighLightCustomerId(0);
                  setHighLightStopId(0);
                  setHighLightCourierId(0);
                  setHighlightLocationId(0);
                }}
                onStopClick={(stopId) => {
                  setHighLightStopId(stopId);
                }}
                onLocationClick={(locationId) => {
                  setHighlightLocationId(locationId);
                }}
                onAction={handleAction}
                renderScorecards={() => <TripsScoreCard scores={tripScores} />}
              />
            </div>
            <div className="chart-area">
              <DndTimelineChart
                viewportWidth={viewportWidth}
                additionAreaWidth={250}
                rowEndAdditionalWidth={100}
                rows={tripRows}
                recycleItems={unAssignedItems}
                showCurrentTime
                itemRender={(item) => <TripDndItem item={item} />}
                itemToolTipRender={(item, rowIndex) => <TripDndItemToolTip item={item} showTimes={rowIndex !== -1} />}
                timebandAdditionalAreaRender={() => {
                  return (
                    <div className="courier-area">
                      <span className="visible-on-map">
                        <IconButton
                          size="small"
                          onClick={() => {
                            handleAllTripVisibilityClick();
                          }}
                        >
                          <Visibility
                            style={{
                              color: allTripIsVisible ? 'lightgray' : 'GrayText',
                              width: 20,
                            }}
                          />
                        </IconButton>
                      </span>
                      <MenuMore
                        items={[
                          {
                            caption: 'Delete invisible trips',
                            icon: <Delete />,
                            color: 'red',
                            disabled: mapTripVisibility.every((tInfo) => tInfo.visibility),
                            onClick() {
                              if (onCustomAction) {
                                onCustomAction({ tripIds: getUnvisibleTripIds() }, 'delete-unvisible-trips');
                              }
                            },
                          },
                        ]}
                      />
                    </div>
                  );
                }}
                additionalAreaRender={(rowIndex) => {
                  const tripIndex = tripRows[rowIndex].index;
                  const trip = tripIndex !== undefined ? trips.find((t) => t.tripId === tripIndex) : undefined;
                  return trip ? (
                    <TripViewTripActions
                      trip={trip}
                      couriers={couriers}
                      timezone={timezone}
                      onMenuSelect={handleTripMenuAction}
                      canComputeStops={canComputeStops && !editable && trip.status === 'FINISHED'}
                      visible={
                        mapTripVisibility.find((tripInfo) => tripInfo.tripId === trip.tripId)?.visibility ?? false
                      }
                      onVisibilityChange={setTripVisibilityOnMap}
                    />
                  ) : (
                    <></>
                  );
                }}
                recycleAreaRender={
                  unAssignedItems.length > 0 ? (isDragStarts) => <SendToToday isDragStarts={isDragStarts} /> : undefined
                }
                rowEndRender={(rowIndex) => {
                  const tripIndex = tripRows[rowIndex].index;
                  const trip = tripIndex ? trips.find((t) => t.tripId === tripIndex) : undefined;
                  const itemsCount = tripRows[rowIndex].items.length;
                  const endTime = displayComputed
                    ? moment(trip?.computedReturnAt)
                    : trip?.isRoundTrip
                    ? moment(trip.returnAt)
                    : moment(tripRows[rowIndex].items[itemsCount - 1]?.end);
                  const totalMinutes = itemsCount > 1 ? endTime.diff(tripRows[rowIndex].items[0].start, 'minutes') : 0;
                  const hours = Math.floor(totalMinutes / 60);
                  const minutes = totalMinutes % 60;
                  const totalTime = ` ${hours > 0 ? hours + 'h' : ''}${minutes > 0 ? minutes + "'" : ''}`;

                  return (
                    <TripViewTripMetrics
                      trip={trip}
                      totalTime={totalTime}
                      displayComputed={!isToday && displayComputed}
                    />
                  );
                }}
                timezone={timezone}
                displayRecycle={unAssignedItems.length > 0}
                onRowReorder={handleRowReorder}
                onBeforeDropToCustomComponent={(sourceRowId, sourceItemIndex, destRowId) => {
                  if (sourceRowId === 'unassigned' && destRowId == 'sendToToday') {
                    handleSendToToday(sourceItemIndex);
                  }
                  return true;
                }}
                onTooltipOpen={onStopTooltipOpen}
                onUnassignedTooltipOpen={onUnassignedTooltipOpen}
                onItemClick={handleOnItemClick}
                onItemDoubleClick={handleOnItemDoubleClick}
                onUnassignedItemClick={handleOnUnassignedItemClick}
                spacerRender={(
                  width: number,
                  rowIndex?: number | undefined,
                  item?: DndTimeLineChartItem | undefined,
                  itemIndex?: number | undefined,
                ) => <TripDndItemSpacer width={width} item={item} itemIndex={itemIndex} rowIndex={rowIndex} />}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default memo(TripView, (prevProps, nextProps) => {
  const prev: any = { ...prevProps };
  const next: any = { ...nextProps };
  prev.unassigned = prev.unAssignedOrders.map((u: any) => ({ id: u.customer?.customerId }));
  next.unassigned = next.unAssignedOrders.map((u: any) => ({ id: u.customer?.customerId }));
  for (const key of [
    ['trips', 'tripId'],
    ['warehouses', 'warehousesId'],
    ['couriers', 'courierId'],
    ['unassigned', 'id'],
  ]) {
    const prevIds = prev[key[0]]
      .map((t: any) => t[key[1]])
      .sort()
      .join('|');
    const nextIds = next[key[0]]
      .map((t: any) => t[key[1]])
      .sort()
      .join('|');
    if (prevIds != nextIds) return false;
  }
  const keys = [
    'date',
    'shipperId',
    'timezone',
    'computedToggle',
    'trackedToggle',
    'canComputeStops',
    'lastTripUpdate',
    'labels',
    'isLoading',
    'adminMode',
  ];
  for (const key of keys) {
    if (prev[key] != next[key]) return false;
  }
  return true;
});
